import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" fillRule="evenodd" d="m8 7.829 4.586 4.586 2.828-2.829L8 2.172.586 9.586l2.828 2.829z" clipRule="evenodd" />
  </svg>
);
export default SvgChevronUp;
